<!--
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-23 16:01:51
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-11-03 15:22:41
 * @FilePath: \standard-v5\src\views\OpinionPublish\OpinionPublishHome.vue
 * @Description: 意向发布-主页
-->
<template>
  <div class="home">
    <head-search
      v-model="params.keyword"
      @searchQuery="search"
      @searchCancel="onCancel"
    ></head-search>
    <div class="container">
      <div class="total">
        <div class="label">所有意向</div>
        <div class="line"></div>
        <div class="number"><span>{{ total }}</span> 项目个数</div>
      </div>
      <div class="list-box">
        <div class="tabs">
          <div class="tab" :class="{ 'active': active==i }" v-for="(item, i) in tabs" :key="i" @click="clickTab(item, i)">
            {{ item.label }}
          </div>
        </div>
        <no-data v-if="list.length == 0"></no-data>
        <div class="list">
          <div class="list-item" v-for="(item, i) in list" :key="i">
            <div class="top">
              <img src="@/assets/img/opinionPublish/home_icon.png">
              <div class="title">{{ item.GCMC }}</div>
            </div>
            <div class="middle">
              <div class="info">
                <div class="label">项目编号</div>
                <div class="value">{{ item.GCBH }}</div>
              </div>
              <div class="info">
                <div class="label">发布对象</div>
                <div class="value">{{ item.FBDX }}</div>
              </div>
              <div class="info">
                <div class="label">有效时间</div>
                <div class="value">{{ item.YXYXQKSSJ }} 至 {{ item.YXYXQJSSJ }}</div>
              </div>
            </div>
            <div class="bottom" @click="checkDetail(item)">
              <span>详情</span>
              <van-icon name="arrow" />
            </div>
          </div>
          <!-- <div class="list-item" v-for="i in 3" :key="i">
            <div class="top">
              <img src="@/assets/img/opinionPublish/home_icon.png">
              <div class="title">湖南电子科技职业学校搬家工程湖南电技职业学校搬家工程</div>
            </div>
            <div class="middle">
              <div class="info">
                <div class="label">项目编号</div>
                <div class="value">LHCH2021011273</div>
              </div>
              <div class="info">
                <div class="label">发布对象</div>
                <div class="value">广东化合勘测有限公司，广东红芯科技有限公司</div>
              </div>
              <div class="info">
                <div class="label">有效时间</div>
                <div class="value">2022-04-29 至 2022-08-17</div>
              </div>
            </div>
            <div class="bottom">
              <span>详情</span>
              <van-icon name="arrow" />
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="btn-box">
      <van-button class="btn" block @click="publishStart" >意向发布</van-button>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api/opinionPublish'
import HeadSearch from '@/components/HeadSearch.vue'
import NoData from '@/components/NoData.vue'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  components: {
    HeadSearch,
    NoData
  },
  mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      tabs: [
        { label: '发布中', value: '1' },
        { label: '未发布', value: '3' },
        { label: '已完结', value: '2' },
        { label: '全部', value: '' },
      ],
      active: 0,
      params: {
        page: 1,
        rows: 20,
        type: '1',
        keyword: ''
      },
      total: 0,
      list: []
    };
  },
  watch: {},
  computed: {
    navTitle() {
      return this.$route.query.title || '意向发布'
    }
  },
  methods: {
    // 搜索测绘作业
    search(val) {
      console.log('搜索值', val)
      this.params.keyword = val
      this.getData()
    },
    // 取消搜索
    onCancel() {
      console.log('点击取消')
      this.params.keyword = ''
      this.getData()
    },
    clickTab(item, i) {
      this.active = i
      this.params.type = item.value
      this.getData()
    },
    publishStart() {
      this.$router.push({ name: 'OpinionPublishProcess' })
    },
    getData() {
      api.queryIntention(this.params).then(res => {
        let data = res.data
        this.list = data.rowsList
      })
    },
    checkDetail(params) {
      this.$router.push({
        name: 'OpinionPublishDetail',
        query: { rid: params.RID }
      })
    },
  },
  created() {
    api.queryIntention({
      page: 1,
      rows: 20,
    }).then(res => {
      this.total = res.data.total
    })
    this.getData(this.params)
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.home {
  .container {
    padding: 60px 15px 0;
  }
  .total {
    width: 100%;
    height: 14vh;
    color: #fff;
    background-image: url('../../assets/img/opinionPublish/home_bg.png');
    background-size: cover;
    background-position: center;

    display: flex;
    align-items: center;
    font-size: 16px;
    .label {
      padding: 0 20px;
    }
    .line {
      width: 1px;
      height: 50px;
      background-color: rgba(255,255,255,.5);
    }
    .number {
      padding-left: 20px;
      span {
        font-size: 22px;
      }
    }
  }
  .list-box {
    .tabs {
      display: flex;
      margin-bottom: 20px;
      .tab {
        padding: 10px 6px;
        margin-right: 15px;
        color: #666;
        &.active {
          color: #1D84FF;
          font-size: 18px;
          font-weight: bold;
          border-bottom: 3px solid #1D84FF;
        }
      }
    }
    .list {
      height: calc(100vh - 18rem);
      overflow-y: auto;
      &-item {
        background-color: #fff;
        border-radius: 5px;
        margin-bottom: 20px;
        .top {
          display: flex;
          align-items: center;
          margin: 0 10px;
          border-bottom: 1px solid #F1F3F6;
          img {
            width: 50px;
            padding: 10px;
            padding-left: 0;
          }
          .title {
            font-weight: bold;
          }
        }
        .middle {
          padding: 10px;
          .info {
            display: flex;
            margin-bottom: 10px;
            font-size: 14px;
            .label {
              width: 80px;
              color: #999;
            }
            .value {
              flex: 1;
              color: #333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #F1F3F6;
          padding: 10px;
          i {
            color: #999;
          }
        }
      }
    }
  }
  .btn-box {
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #f1f3f6;
    bottom: 0;
    position: fixed;
    padding: 10px 15px;
    box-sizing: border-box;
    .btn {
      background: #0086ff;
      box-shadow: 0px 2px 6px 0px rgba(29, 132, 255, 0.5);
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      padding: 14px 0;
      text-align: center;
      border: 1px solid transparent;
    }
  }
}
</style>